// SCROLL TO TOP SCRIPT 
var scrollToTopBtn = document.querySelector(".scrollToTopBtn")
var rootElement = document.documentElement

function handleScroll() {
var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
if ((rootElement.scrollTop / scrollTotal ) > 0.2) {
// 0.2 is the percentage the page has to scroll before the button appears

  // Show button
scrollToTopBtn.classList.add("showBtn")
} else {
  // Hide button
  scrollToTopBtn.classList.remove("showBtn")
}
}

function scrollToTop() {
// Scroll to top logic
rootElement.scrollTo({
  top: 0,
  behavior: "smooth"
})
}
scrollToTopBtn.addEventListener("click", scrollToTop)
document.addEventListener("scroll", handleScroll)
